import { Typography } from '@mui/material';
import { Disparity } from '../../types/Disparity/Disparity.type';
import { ComparisonPoolType } from '../../types/enums/ComparisonPoolType.enum';
import { DisparitySubType } from '../../types/enums/DisparitySubType.enum';
import { DisparityType } from '../../types/enums/DisparityType.enum';
import { hasDisparityCounts } from '../../utils/hasDisparityCounts';
import ComparatorChart from './ComparatorChart';
import EnhancementChart from './EnhancementChart';
import PerCapitaChart from './PerCapitaChart';
import TransitionChart from './TransitionChart';
import WobblerChart from './WobblerChart';

function ChartContainer({ disparityData }: { disparityData: Disparity }) {
  if (!hasDisparityCounts(disparityData))
    return (
      <Typography variant='body2' sx={{ fontWeight: 500 }}>
        No comparison data available for this disparity.
      </Typography>
    );

  switch (disparityData.type.id) {
    case DisparityType.SEVERITY:
      switch (disparityData.subtype.id) {
        case DisparitySubType.WOBBLERS:
          return <WobblerChart disparityData={disparityData} />;
        case DisparitySubType.TARGET_VERSUS_COMPARATORS:
          if (
            disparityData.comparison_pools.find((pool) => pool.comparison_pool_type.id === ComparisonPoolType.INCLUSION)
          )
            return <ComparatorChart disparityData={disparityData} />;
          return (
            <Typography variant='body2' sx={{ fontWeight: 500 }}>
              No comparison data available. Please add comparison cases first.
            </Typography>
          );
        case DisparitySubType.ENHANCEMENT:
          return <EnhancementChart disparityData={disparityData} />;
        default:
          return (
            <Typography variant='body2' sx={{ fontWeight: 500 }}>
              No comparison data available for this disparity.
            </Typography>
          );
      }
    case DisparityType.TRANSITION:
      return <TransitionChart disparityData={disparityData} />;
    case DisparityType.PER_CAPITA:
      return <PerCapitaChart disparityData={disparityData} />;
    default:
      return (
        <Typography variant='body2' sx={{ fontWeight: 500 }}>
          No comparison data available for this disparity.
        </Typography>
      );
  }
}

export default ChartContainer;
